import React from 'react';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import GitHubIcon from '@material-ui/icons/GitHub';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  profileContent: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  inlineIcon: {
    verticalAlign: 'middle',
  },
}));

interface PersonalInfo {
  picture?: string;
  name?: string;
  github?: string;
  email?: string;
}

export default function PersonalInfoCardContent({ info } : { info: PersonalInfo }) {
  const classes = useStyles();
  return (
    <CardContent className={classes.profileContent}>
      <Avatar className={classes.avatar} src={info?.picture}><AccountCircleIcon /></Avatar>
      <Typography variant="h3" align="center">{info.name || 'Your Name'}</Typography>
      {info?.github && (
        <Typography variant="h4" align="center">
          <GitHubIcon className={classes.inlineIcon} fontSize="inherit" />
          {' '}
          {/* @ */}
          {info.github}
        </Typography>
      )}
      {info?.email && (
        <Typography variant="h4" align="center">
          {info.email}
        </Typography>
      )}
    </CardContent>
  );
}
